import { createAction, props } from '@ngrx/store';

export const SET_CHANGED_FLIGHT_STATE = '[confirmation page] Set changed flight flag state';

export const setChangedFlightFlagState = createAction(SET_CHANGED_FLIGHT_STATE, props<{ wasFlightChangeConfirmed: boolean }>());
